import React from "react";
import { Flex, Space, Spin } from "antd";
import { BookingTransactionDetails, BookingAddOns } from "../../../interfaces/booking.interface";
import { currencyDisplay, fareSumLabel, priceTypeLabel } from "../../../utils/helpers";

const PricingSummary2 = (
  props: {
    summary: BookingTransactionDetails;
    addOns?: BookingAddOns[];
    showAdminFee: boolean;
    currencyAdminFee: string;
    currencyGrandTotal: string;
    currencyAddOnsTotal: string;
    showNonMalaysiaCharge?: boolean;
    currencyNonMalaysiaCharges?: string;
    showVisaFee?: boolean;
    currencyVisaFee?: string;
    promotionDeductions?: { title: string; entitledPaxCount: number; currencyAmount: string }[];
    loading?: boolean;
    cabin?: number;
    depositPaymentSelected?: boolean;
    currencyDeposit?: string;
    dueDate?: string;
    currencyBalance?: string;
  }
) => {
  const {
    summary,
    addOns = [],
    showAdminFee,
    currencyAdminFee,
    currencyGrandTotal,
    currencyAddOnsTotal,
    showNonMalaysiaCharge = false,
    currencyNonMalaysiaCharges = "",
    showVisaFee = false,
    currencyVisaFee = "",
    promotionDeductions = [],
    loading = false,
    cabin,
    depositPaymentSelected = false,
    currencyDeposit,
    dueDate,
    currencyBalance
  } = props;

  return (
    <div className="pricing-summary-v2">
      <Flex vertical className="pricing-summary-booking-details">
        {
          cabin && (
            <div className="pricing-summary-booking-details-items highlight">
              <span> Cabin </span>
              <span> x {cabin} </span>
            </div>
          )
        }

        {
          summary?.fareBreakdown?.items?.length > 0 && (
            <div className="pricing-summary-booking-details-breakdown">
              {
                summary?.fareBreakdown?.items.map((item: { category: string; count: number; sum: number; tiers?: { price_type: string; price: number; count: number; sum: number }[] }, index) => (
                  item.category && (
                    item.tiers && item.tiers.length > 0 ? (
                      item.tiers.map((tier, tierIndex) => (
                        <div key={`${index}-${tierIndex}`} className="pricing-summary-booking-details-items">
                          <span> {priceTypeLabel(tier.price_type)} {item.category} x {tier.count} </span>
                          <span>{fareSumLabel(summary.priceCurrency, tier.sum)}</span>
                        </div>
                      ))
                    ) : (
                      <div key={index} className="pricing-summary-booking-details-items">
                        <span> {item.category} x {item.count} </span>
                        <span>{fareSumLabel(summary.priceCurrency, item.sum)}</span>
                      </div>
                    )
                  )
                ))
              }

              {
                addOns.map((addon, index) => (
                  <div key={index} className="pricing-summary-booking-details-items">
                    <span>{addon.label}</span>
                    <span>{addon.totalPax} x {currencyDisplay(summary?.priceCurrency, addon.perPaxValue ?? addon.value)}</span>
                  </div>
                ))
              }


              {
                showNonMalaysiaCharge && currencyNonMalaysiaCharges && (
                  <div className="pricing-summary-booking-details-items">
                    <span>Non-Malaysian Charge</span>
                    <span>{currencyNonMalaysiaCharges}</span>
                  </div>
                )
              }

              {
                showVisaFee && currencyVisaFee && (
                  <div className="pricing-summary-booking-details-items">
                    <span>Visa Fee</span>
                    <span>- {currencyVisaFee}</span>
                  </div>
                )
              }

              {
                !loading && promotionDeductions.map((promo, index) => (
                  <div key={index} className="pricing-summary-booking-details-items">
                    <span>{promo.title} x {promo.entitledPaxCount}</span>
                    <span>- {promo.currencyAmount}</span>
                  </div>
                ))
              }

              {
                (showAdminFee) && (
                  <div className="pricing-summary-booking-details-items">
                    <span>Admin Fee</span>
                    <span>{currencyAdminFee} </span>
                  </div>
                )
              }
              <div className="pricing-summary-booking-details-total">
                {
                  depositPaymentSelected && (
                    <div className="deposit-highlight">
                      <Space size="small" style={{ display: "flex"}} direction="vertical">
                        <Flex gap={5} align="center" justify="space-between">
                          <span>Deposit</span>
                          <span>-{currencyDeposit}</span>
                        </Flex>
                        <Flex gap={5} align="center" justify="space-between" className="due-date">
                          <span>Due Date</span>
                          <span>{dueDate}</span>
                        </Flex>
                        
                        <Flex gap={5} align="center" justify="space-between" className="balance">
                          <span>Remaining Balance</span>
                          <span>{currencyBalance}</span>
                        </Flex>
                        
                      </Space>
                    </div>
                  )
                }

                <div className="grand-total">
                  <span>Total</span>
                  <span>{loading ? <Spin size="small" /> : currencyGrandTotal}</span>
                </div>
              </div>
            </div>
          )
        }    
      </Flex>
    </div>
  )
}

export default PricingSummary2;